<template>
    <div class="commercial-policy-amount">
        <v-row class="px-0" v-for="(item, idx) in policies" :key="idx">
            <v-col cols="12" class="col-md-4">
                <policy-date-picker :date-key="dateKeyStart" label="Дата начала" :idx="idx" :initial="item.dates[0] || null" @change="changeDate"/>
            </v-col>
            <v-col cols="12" class="col-md-4">
                <policy-date-picker :date-key="dateKeyFinish" label="Дата окончания" :idx="idx" :initial="item.dates[1] || null" @change="changeDate"/>
            </v-col>
            <v-col cols="12" class="col-md-4">
                <v-text-field v-model="policies[idx].discount" label="Размер скидки" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="12" class="mt-0">
                <v-btn text color="grey" @click="deletePolicy(item.id)">Удалить политику</v-btn>
            </v-col>
            <v-col cols="12" class="pa-0">
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import CommercialPolicyMixin from "./CommercialPolicyMixin"
    import CommercialPolicyDatePicker from "./CommercialPolicyDatePicker"

    export default {
        name: "CommercialPolicyDate",
        props:['currencies'],
        mixins: [CommercialPolicyMixin],
        components: {PolicyDatePicker: CommercialPolicyDatePicker},
        data() {
            return {
                dateKeyStart: 'startDate',
                dateKeyFinish: 'finishDate',
            }
        },
        methods: {
            changeDate(data) {
                const dateIdx = data.key === this.dateKeyStart ? 0 : 1;
                this.policies[data.idx].dates[dateIdx] = data.date;
                this.changePolicy();
            }
        },
    }
</script>

<style scoped>

</style>